import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from 'src/app/core/helpers/auth-interceptor';

import { BillingComponent } from 'src/app/modules/main/pages/billing/billing.component';
import { BillingRoutingModule } from 'src/app/modules/main/pages/billing/billing-routing.module';

import { HeaderModule } from 'src/app/core/header/header.module';
import { FooterModule } from 'src/app/core/footer/footer.module';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { StripeDialogComponent } from './invoice-details/stripe-dialog/stripe-dialog.component';
// tslint:disable-next-line: max-line-length
import { AccountBalanceBillingCardComponent } from 'src/app/shared/components/card/account-balance-billing-card/account-balance-billing-card.component';

@NgModule({
    imports: [
        BillingRoutingModule,
        BillingComponent,
        InvoiceDetailsComponent,
        StripeDialogComponent,
        AccountBalanceBillingCardComponent
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ]
})

export class BillingModule { }
